import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

export const AtlassianIntelligenceImage = () => {
    const intl = useIntl();

    const messages = {
        altText: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AtlassianIntelligence.altText",
            defaultMessage: "Atlassian Intelligence"
        })
    };

    return (
        <img
            src="https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_AI.webp"
            alt={messages.altText}
            height={350}
            loading="lazy"
        />
    );
};

const AtlassianIntelligence = () => {
    const intl = useIntl();

    const LearnMoreLink = `https://support.atlassian.com${useLocalizedHref(
        "/organization-administration/docs/get-started-with-atlassian-intelligence/"
    )}`;

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AtlassianIntelligence.header",
            defaultMessage: "Atlassian Intelligence (AI)"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AtlassianIntelligence.body",
            defaultMessage:
                "Cut down on tedious tasks and empower any team to deliver exceptional service experiences with AI-powered ITSM capabilities."
        }),
        body2: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AtlassianIntelligence.body2",
            defaultMessage:
                "These include generative AI responses in the virtual agent, AI-powered editing experiences, quick issue summaries, and more."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.AtlassianIntelligence.link",
                defaultMessage:
                    "Atlassian Intelligence (AI) features are not activated by default. Organization admins must opt-in to activate AI-powered capabilities for all teams. <learnMore>Learn more.</learnMore>"
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href={LearnMoreLink}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.body2}</p>
            <p>{messages.link}</p>
            <AtlassianIntelligenceImage />
        </>
    );
};

export default AtlassianIntelligence;
